import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../Firebase/Config";
import RouteWithTitle from '../../../Layout/RouteWithTitle';
import Header from "./Header/Header";
import Loading from "../Loading/Loading";

function Project() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    const ref = collection(db, "project");
    getDocs(ref).then((snapshot) => {
      if (snapshot.empty) {
        setError("خطایی رخ داد");
        setLoading(false);
      } else {
        setLoading(false);
        let result = [];
        snapshot.docs.forEach((doc) => {
          result.push({ id: doc.id, ...doc.data() });
        });
        setData(result);
      }
    });
  }, []);

  return (
    <RouteWithTitle>
    <div dir="rtl" id="project" className="Container">
      <Header />
      <div className="flex flex-wrap justify-between">
      {error ? (
          error
        ) : loading ? (
          <Loading />
        ) : data ? (
          <div className="flex flex-wrap text-white">
            {data
            .sort((a, b) => a.Id - b.Id)
            .map(item => (
            <div className="xl:w-1/3 xl:p-5 py-5 sm:w-full" key={item.Id}>
              <a
                href={item.Href}
                className="no-underline transition-all inline-block text-custom_blue font hover:transition-all"
              >
                <h3 className="mb-5 font-bold">{item.Title}</h3>
              </a>
              <p className="font-extralight text-base text-black text-justify">
                {item.Description}
              </p>
            </div>
            ))}
          </div>
        ) : (
          <p>داده‌ای وجود ندارد</p>
        )}
      </div>
    </div>
    </RouteWithTitle>
  );
}

export default Project;